import React from 'react';

import styles from '../styles/StatusBadgeStyle.less';

export type BadgeColor = 'green' | 'red';

export interface IStatusBadgeProps {
  status: string;
  color: BadgeColor;
}

const StatusBadge: React.FC<IStatusBadgeProps> = (props) => {
  const { color, status } = props;

  return (
    <div className={styles.badge}>
      <div className={`${styles.indicator} ${styles[`indicator-${color}`]}`} />
      <div>{status}</div>
    </div>
  );
};

export default StatusBadge;
